import { Chip, IconButton, TextField } from "@material-ui/core";
import ShareIcon from "@material-ui/icons/Share";
import Autocomplete from "@material-ui/lab/Autocomplete";
import PropTypes from "prop-types";
import { useState } from "react";
import DialogModal from "../UI/DialogModals";

import { lang } from "../../i18nLang";
import { ContractListStore, ContractStore } from "../../store";

type IProps = {
  id: string;
  className: string;
};

/** Componente Menu suspenso com as ações a serem feitas no contrato.
 * Inclusive o Dialog para compartilhar um contrato com um ou
 * mais usuários
 */
const ContractShareButton = ({ id, className }: IProps) => {
  const [openModal, setOpenModal] = useState(false);
  const [selectedEmails, setSelectedEmails] = useState<string[]>([]);

  /** Exibe a modal de compartilhar o contrato e carrega os
   * e-mails do usuários atuais.
   */
  const handleOpenModal = async (ev) => {
    ev.stopPropagation();
    const contract = ContractListStore.findContract(id);
    const users = await ContractStore.getContractUsers(contract);
    const emails = users.map((user) => user.email);

    setSelectedEmails(emails);
    setOpenModal(true);
  };

  /** Oculta a modal de compartilhar contrato. */
  const handleCloseModal = () => setOpenModal(false);

  /** Evento ao mudar input de emails dos usuários.
   * Só é chamado após digitar um valor e apertar ENTER!
   */
  const handleInputChange = (ev, value: any, reason) => {
    setSelectedEmails(value);
  };

  /** Evento ao sair do input de emails dos usuários. */
  const handleInputBlur = (ev) => {
    const value = ev.target?.value;
    if (value) setSelectedEmails([...selectedEmails, value]);
  };

  /** Evento confirmar da modal. */
  const handleShareUsers = () => {
    const contract = ContractListStore.findContract(id);
    ContractStore.shareContratWithUsers(contract, selectedEmails).then(
      (success) => {
        if (success) handleCloseModal();
      }
    );

    return true; // Para não fechar a modal
  };

  /** Verifica se o usuário logado é o proprietário do contrato,
   * caso não seja, oculta o botão para abrir o menu suspenso.
   */
  const canEnable = () => {
    const contract = ContractListStore.findContract(id);
    return ContractStore.userIsOwnerOf(contract);
  };

  if (!canEnable()) return <></>;

  const iconStyle = { marginRight: "0.3rem", fontSize: "1rem" };
  return (
    <>
      <IconButton className={className} type="button" onClick={handleOpenModal}>
        <ShareIcon style={iconStyle} />
      </IconButton>

      <DialogModal
        open={openModal}
        title={lang("kanban.shareModal.title")}
        confirmLabel={lang("completed")}
        onClose={handleCloseModal}
        onConfirm={handleShareUsers}
        onClick={(event) => event.stopPropagation()}
      >
        <Autocomplete
          multiple
          id="selectedEmails"
          options={[]}
          value={selectedEmails}
          limitTags={8}
          freeSolo
          onChange={handleInputChange}
          onBlur={handleInputBlur}
          renderTags={(value, getTagProps) => {
            return value.map((option, index) => (
              <Chip
                variant="outlined"
                label={option}
                color="primary"
                {...getTagProps({ index })}
              />
            ));
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              placeholder={
                selectedEmails.length
                  ? lang("kanban.shareModal.addAnother")
                  : lang("kanban.shareModal.addEmails")
              }
              margin="normal"
            />
          )}
        />
      </DialogModal>
    </>
  );
};

ContractShareButton.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
};

export default ContractShareButton;
